import { render, staticRenderFns } from "./commission-chart.vue?vue&type=template&id=382f7685"
import script from "./commission-chart.vue?vue&type=script&lang=js"
export * from "./commission-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports